﻿import { CustomBasket } from "./custom.class.basket.js";
import { opaccLogPlugin, opaccAjaxPlugin } from './vendor/script/opacc.static.js';
import { formErrorMessages } from './vendor/script/messages/opacc.messages.js';

/** @module basket */

/**
 * Warenkorb funktionalität
 *
 * @extends {OpaccBasket}
 */
export class CustomBasketAction extends CustomBasket {
	constructor(
		basketButtonContainer = '.opc-basket-button',
		basketButtonSelector = 'button'
	) {
		super();
		this.basketButtonContainer = basketButtonContainer;
		this.basketButtonSelector = basketButtonSelector;
		this.attachEventListener();

        let articleAllowanceUrlWrapper = document.getElementById('article-allowance-url');
        if(articleAllowanceUrlWrapper && articleAllowanceUrlWrapper.hasAttribute('data-op-url') && articleAllowanceUrlWrapper.getAttribute('data-op-url') != '') {
            this.articleAllowanceUrl = articleAllowanceUrlWrapper.getAttribute('data-op-url');
        }
	}

	/**
	 *
	 *
	 */
	attachEventListener() {
		if (this.wrapperElement) {
			this.changeDimVariant();

			// Ausloesen des Click-Events bei Aenderung (nur Touch-Button "Change")
			this.wrapperElement.addEventListener('change', e => {
				let inputItem = e.target.closest(`${this.basketButtonContainer}[data-op-layout="touch"]`);
				if (inputItem) {
					let basketBtn = inputItem.querySelector('button[data-op-btnaction="change"]');
					if (basketBtn) {
						basketBtn.click();
					}
				}
			});

			this.wrapperElement.addEventListener('click', e => {
				let modalButton = e.target.closest('[data-op-modal]');
				if (modalButton) {
					let base64 = modalButton.dataset.opModal;
					let htmlEncoded = window.atob(base64);
					let htmlDecode = document.createElement('div');
					htmlDecode.innerHTML = htmlEncoded;
					opaccLogPlugin.showModal(htmlDecode.innerText);
				}

				// change Quantity with + and - Buttons
				let itemChangeQuantity = e.target.closest(`${this.basketButtonContainer}[data-op-layout="touch"]`);
				if (itemChangeQuantity && e.target.hasAttribute('data-op-qtychange')) {
					if (this.quantityChanger(e)) {
						let item = itemChangeQuantity.querySelector(`${this.basketButtonContainer} button[data-op-btnaction="change"]`);
						if (item) {
							// if change-button is present, then trigger the quantity change
							item.click();
						}
					}
				}

				let itemsAdd = e.currentTarget.querySelectorAll(`${this.basketButtonContainer} button[data-op-btnaction="add"], ${this.basketButtonContainer} button[data-op-btnaction="addall"]`);
				Array.from(itemsAdd).forEach(item => {
					// laufender Request: Doppelklick ignorieren
					if (item == e.target.closest(this.basketButtonSelector) && !item.classList.contains('is-progress')) {
						let inputField = item.parentElement.querySelector('input.basket-button-quantity');
						let isValid = true;
						if (inputField) {
							isValid = this.validateQuantity(inputField,true);
						}
						if (isValid) {
							if (this.basketInfo) {
								item.dataset.opAsynctemplate = this.basketInfo.dataset.opAsynctemplate;
							}
							item.classList.add('is-progress');
							// sendAjaxRequest wird nach erfolgreicher Freigabepruefung in showAllowanceInfo ausgefuehrt
							this.checkAllowance(item);
						}
					}
				});

				let itemsModify = e.currentTarget.querySelectorAll(
					`${this.basketButtonContainer} button[data-op-btnaction="delete"], 
					${this.basketButtonContainer} button[data-op-btnaction="change"],
					${this.basketButtonContainer} button[data-op-btnaction="deleteall"]`
				);
				Array.from(itemsModify).forEach(item => {
					// laufender Request: Doppelklick ignorieren
					if (item == e.target.closest(this.basketButtonSelector) && !item.classList.contains('is-progress')) {
						if (item.dataset.opBtnaction == 'change') {
							this.validateQuantity(item.parentElement.querySelector('input.basket-button-quantity'),true);
							this.toggleQuantityChangerState(this.getQuantityChangerElements(e.target), 'none');
						}
						if (this.basketInfo) {
							item.dataset.opAsynctemplate = this.basketInfo.dataset.opAsynctemplate;
						}
						item.classList.add('is-progress');
						this.sendAjaxRequest(item);
					}
				});
			});
		}
	}

	/**
	 * Freigabepruefung (Bewilligung) vor dem Hinzufuegen in den Warenkorb
	 *
	 * @param {*} item
	 */
	checkAllowance(item) {
		// ohne Pruef-URL direkt hinzufuegen, damit der Warenkorb nicht blockiert
		if (!this.articleAllowanceUrl) {
			this.sendAjaxRequest(item);
			return;
		}

		let data = {
			artIntNo: item.dataset.opArtinternalno
		};
		opaccAjaxPlugin.fetchAsynPostForm(this.articleAllowanceUrl, data, this.showAllowanceInfo.bind(this, item), this.allowanceErrorHandler.bind(this, item), true);
	}

	/**
	 *
	 * @param {*} item
	 * @param {*} response
	 */
	showAllowanceInfo(item, response) {
		let result = response && response.dataAsJson;
		if (!result) {
			this.allowanceErrorHandler(item);
			return;
		}

		if (result.code == '0') {
			item.classList.remove('is-progress');
			opaccLogPlugin.showModal(result.showInfoMessage);
		} else {
			this.sendAjaxRequest(item);
		}
	}

	/**
	 *
	 * @param {*} item
	 * @param {*} error
	 */
	allowanceErrorHandler(item, error) {
		item.classList.remove('is-progress');
		opaccAjaxPlugin.getDefaultErrorFnc(error);
	}

	/**
	 *
	 *
	 * @param {*} e
	 * @returns {*}
	 */
	quantityChanger(e) {
		let decrementButton = e.target.parentElement.querySelector('.opc-button[data-op-qtychange="dec"]');
		let incrementButton = e.target.parentElement.querySelector('.opc-button[data-op-qtychange="inc"]');
		let inputField = e.target.parentElement.querySelector('input.basket-button-quantity');
		let step = parseFloat(inputField.getAttribute('step') || 1);
		let min = parseFloat(inputField.getAttribute('min') || step);
		let max = parseFloat(inputField.getAttribute('max') || 0);
		let isMaxSet = inputField.getAttribute('max') ? true : false;
		let artDimCheck = inputField.dataset.opArtdimcheckcd ? inputField.dataset.opArtdimcheckcd : 0;

		let oldValue = parseFloat(inputField.value) || 0;
		let hasChanged = false;
		let operator = null;
		// Wert erhoehen
		if (incrementButton && e.target === incrementButton) {
			operator = '+';
			if (oldValue < min) { operator = '-'; }
		}
		// Wert verringern
		else if (decrementButton && e.target === decrementButton) {
			operator = '-';
			if (oldValue > max && isMaxSet) { operator = '+'; }
		}
		// Enter-Taste betätigen
		else if (e.keyCode === 13) {
			if (oldValue > max) { operator = '+'; }
			else if (oldValue < min) { operator = '-'; }
		}

		if (+artDimCheck > 0 ) {
			let multiplikator = this.countDecimals(step);
			let currentValPow = oldValue * Math.pow(10, multiplikator);
			let stepPow = step * Math.pow(10, multiplikator);
			if (currentValPow === 0 || (currentValPow % stepPow !== 0) && oldValue >= min) {
				let result = (currentValPow + stepPow - (currentValPow % stepPow)) / Math.pow(10, multiplikator);
				opaccLogPlugin.showMessage(formErrorMessages.messageStepAdjust, formErrorMessages.messageStepAdjust.text.replace('{currentValue}', oldValue).replace('{newValue}', result).replace('{step}', step));
				operator = '+';
			}
		}

		hasChanged = this.setCalculatedQuantityField(oldValue, operator, inputField, step, min, max);
		return hasChanged;
	}

	/**
	 *
	 *
	 * @param {*} qtyField
	 * @param {boolean} [changeToValidQuantity=true]
	 * @returns {*}
	 */
	validateQuantity(qtyField, changeToValidQuantity = true) {
		let step = parseFloat(qtyField.getAttribute('step') || 1);
		let min = parseFloat(qtyField.getAttribute('min') || step);
		let max = parseFloat(qtyField.getAttribute('max') || 0);
		let isMaxSet = qtyField.getAttribute('max') ? true : false;
		let currentVal = parseFloat(qtyField.value) || 0;
		let artDimCheck = qtyField.dataset.opArtdimcheckcd ? qtyField.dataset.opArtdimcheckcd : 0;

		if (currentVal < min || (currentVal > max && isMaxSet)) {
			let operator = null;
			if (currentVal > max && isMaxSet) {
				operator = '+';
			} else if (currentVal < min) {
				operator = '-';
			}

			this.setCalculatedQuantityField(currentVal, operator, qtyField, step, min, max);
			return false;
		}

		if (+artDimCheck > 0 ) {
			let multiplikator = this.countDecimals(step);
			let currentValPow = currentVal * Math.pow(10, multiplikator);
			let stepPow = step * Math.pow(10, multiplikator);
			if (currentValPow === 0 || currentValPow % stepPow !== 0) {
				if (changeToValidQuantity) {
					let result = (currentValPow + stepPow - (currentValPow % stepPow)) / Math.pow(10, multiplikator);
					opaccLogPlugin.showMessage(formErrorMessages.messageStepAdjust, formErrorMessages.messageStepAdjust.text.replace('{currentValue}', currentVal).replace('{newValue}', result).replace('{step}', step));
					return this.setCalculatedQuantityField(currentVal, '+', qtyField, step, min, max);
				}
				return false;
			}
		} else if (+artDimCheck === 0){
			let multiplikator = this.countDecimals(+qtyField.value);

			if (multiplikator > 2) {
				let result = parseFloat(qtyField.value).toFixed(2);
				qtyField.value = result;
				opaccLogPlugin.showMessage(formErrorMessages.messageToMuchDec, formErrorMessages.messageToMuchDec.text.replace('{newValue}', result));
			}
		}

		return true;
	}

	/**
	 *
	 *
	 * @param {*} currentVal
	 * @param {*} operator
	 * @param {*} qtyField
	 * @param {*} step
	 * @param {*} min
	 * @param {*} [max=null]
	 * @returns {*}
	 */
	setCalculatedQuantityField(currentVal, operator, qtyField, step, min, max = null) {
		let multiplikator = this.countDecimals(step);
		let currentValPow = currentVal * Math.pow(10, multiplikator);
		let stepPow = step * Math.pow(10, multiplikator);
		let minPow = min * Math.pow(10, multiplikator);
		let maxPow = max * Math.pow(10, multiplikator);
		let newValuePow = currentValPow;
		let artDimCheck = qtyField.dataset.opArtdimcheckcd ? qtyField.dataset.opArtdimcheckcd : 0;

		switch (operator) {
		case '-':
			newValuePow = currentValPow - (+artDimCheck === 0 ?  stepPow : (currentValPow % stepPow == 0 ? stepPow : currentValPow % stepPow));
			if (newValuePow < minPow) {
				newValuePow = minPow;
				opaccLogPlugin.showMessage(formErrorMessages.messageRangeUnderflow, formErrorMessages.messageRangeUnderflow.text.replace('{min}', min));
			}
			break;
		case '+':
		default:
			newValuePow = (currentValPow + stepPow - (+artDimCheck > 0 ? (currentValPow % stepPow) : 0));
			if (maxPow != null && +maxPow > 0 && newValuePow > maxPow) {
				newValuePow = maxPow;
				opaccLogPlugin.showMessage(formErrorMessages.messageRangeOverflow, formErrorMessages.messageRangeOverflow.text.replace('{max}', max));
			}
			break;
		}

		// Wert veraendert und Step beruecksichtigt?
		if (newValuePow !== currentValPow) {
			if (newValuePow % stepPow === 0) {
				qtyField.value = parseFloat(newValuePow / Math.pow(10, multiplikator));
				return true;
			} else if (+artDimCheck === 0) {
				qtyField.value = parseFloat(newValuePow / Math.pow(10, multiplikator));
				return true;
			} else {
				newValuePow = currentValPow;
				opaccLogPlugin.showMessage(formErrorMessages.messageStepMismatch, formErrorMessages.messageStepMismatch.text.replace('{step}', step));
			}
		}
		return false;
	}

	/**
	 *
	 *
	 * @param {*} value
	 * @returns {*}
	 */
	countDecimals(value) {
		if(Math.floor(value) === value) return 0;
		return value.toString().split('.')[1].length || 0;
	}

	/**
	 *
	 *
	 */
	changeDimVariant() {
		this.wrapperElement.addEventListener('change', e => {
			let dimVariantSelectBox = e.target.closest('.basket-button-dim-variants');
			if (dimVariantSelectBox) {
				let selectedOption = dimVariantSelectBox.querySelector(`option[value="${dimVariantSelectBox.value}"]`);

				let dim1Value = selectedOption.dataset.opDim1value ? selectedOption.dataset.opDim1value : 0;
				let dim2Value = selectedOption.dataset.opDim2value ? selectedOption.dataset.opDim2value : 0;
				let dim3Value = selectedOption.dataset.opDim3value ? selectedOption.dataset.opDim3value : 0;

				let dim1Name = selectedOption.dataset.opDim1name ? selectedOption.dataset.opDim1name : '';
				let dim2Name = selectedOption.dataset.opDim2name ? selectedOption.dataset.opDim2name : '';
				let dim3Name = selectedOption.dataset.opDim3name ? selectedOption.dataset.opDim3name : '';

				let dim1Unit = selectedOption.dataset.opDim1unit ? selectedOption.dataset.opDim1unit : '';
				let dim2Unit = selectedOption.dataset.opDim2unit ? selectedOption.dataset.opDim2unit : '';
				let dim3Unit = selectedOption.dataset.opDim3unit ? selectedOption.dataset.opDim3unit : '';

				let artDimCheckCd = selectedOption.dataset.opArtdimcheckcd ? selectedOption.dataset.opArtdimcheckcd : '';

				let dim1Min = selectedOption.dataset.opDim1min ? selectedOption.dataset.opDim1min : '';
				let dim1Max = selectedOption.dataset.opDim1max ? selectedOption.dataset.opDim1max : '';
				let dim1Step = selectedOption.dataset.opStep ? selectedOption.dataset.opStep : '';

				// Überprüfung, ob die Dimensionen aktiv sind
				let dim1Active = dim1Name || dim1Unit;
				let dim2Active = dim2Name || dim2Unit;
				let dim3Active = dim3Name || dim3Unit;

				let basketButtonElem = e.target.closest(this.basketButtonContainer);
				let basketButton = basketButtonElem.querySelector(
					'button[data-op-btnaction="add"]'
				);
				if (!basketButton) {
					basketButton = basketButtonElem.querySelector(
						'button[data-op-btnaction="change"]'
					);
				}

				// Wenn Dimensionsvariante ändert, diese auf dem Warenkorb-Button nachführen
				if (basketButton && basketButton.dataset.opVariant) {
					basketButton.dataset.opVariant = dimVariantSelectBox.value;
				}

				let dim1 = basketButtonElem.querySelector('.basket-button-dim-1');
				let dim2 = basketButtonElem.querySelector('.basket-button-dim-2');
				let dim3 = basketButtonElem.querySelector('.basket-button-dim-3');

				dim1.classList.remove('is-inactive');
				dim2.classList.remove('is-inactive');
				dim3.classList.remove('is-inactive');

				// Falls Dimension 1 und 2 nicht aktiv sind, wird das Element als "inactive" gekennzeichnet
				if (!(dim1Active && dim2Active)) {
					dim2.classList.add('is-inactive');
				}
				// Falls Dimension 1 und 3 nicht aktiv sind, wird das Element als "inactive" gekennzeichnet
				if (!(dim1Active && dim3Active)) {
					dim3.classList.add('is-inactive');
				}
				// Falls mehrere Dimensionen aktiv sind, wird das umschliessende Element als "multi-dim" gekennzeichnet
				if (dim2Active || dim3Active) {
					basketButtonElem.dataset.opType = 'multi-dim';
				} else {
					basketButtonElem.dataset.opType = 'single-dim';
				}

				let inputFieldDim1 = dim1.querySelector('.basket-button-quantity');
				let inputFieldDim2 = dim2.querySelector('.basket-button-quantity');
				let inputFieldDim3 = dim3.querySelector('.basket-button-quantity');

				inputFieldDim1.value = dim1Value ? dim1Value : '';
				inputFieldDim1.dataset.opArtdimcheckcd = artDimCheckCd ? artDimCheckCd : '';

				if (+dim1Min > 0) {
					inputFieldDim1.setAttribute('min', dim1Min);
				} else {
					inputFieldDim1.removeAttribute('min');
				}

				if (+dim1Max > 0) {
					inputFieldDim1.setAttribute('max', dim1Max);
				} else {
					inputFieldDim1.removeAttribute('max');
				}

				if (+dim1Step > 0) {
					inputFieldDim1.setAttribute('step', dim1Step);
				} else {
					inputFieldDim1.removeAttribute('step');
				}

				inputFieldDim2.value = dim2Value ? dim2Value : '';
				inputFieldDim3.value = dim3Value ? dim3Value : '';

				let dim1NameElement = dim1.querySelector('.basket-button-dim-name') || undefined;
				let dim1UnitElement = dim1.querySelector('.basket-button-dim-unit') || undefined;
				let dim2NameElement = dim2.querySelector('.basket-button-dim-name') || undefined;
				let dim2UnitElement = dim2.querySelector('.basket-button-dim-unit') || undefined;
				let dim3NameElement = dim3.querySelector('.basket-button-dim-name') || undefined;
				let dim3UnitElement = dim3.querySelector('.basket-button-dim-unit') || undefined;

				if (dim1NameElement) {
					dim1NameElement.innerHTML = dim1Name.length > 0 ? dim1Name : '';
				}
				if (dim1UnitElement) {
					dim1UnitElement.innerHTML = dim1Unit.length > 0 ? dim1Unit : '';
				}
				if (dim2NameElement) {
					dim2NameElement.innerHTML = dim2Name.length > 0 ? dim2Name : '';
				}
				if (dim2UnitElement) {
					dim2UnitElement.innerHTML = dim2Unit.length > 0 ? dim2Unit : '';
				}
				if (dim3NameElement) {
					dim3NameElement.innerHTML = dim3Name.length > 0 ? dim3Name : '';
				}
				if (dim3UnitElement) {
					dim3UnitElement.innerHTML = dim3Unit.length > 0 ? dim3Unit : '';
				}
			}
		});
	}

	/**
	 *
	 *
	 * @param {*} item
	 */
	showSuccessIndicator(item) {
		item.classList.toggle('is-success');
		let indicator = setTimeout(() => {
			item.classList.toggle('is-success');
			clearTimeout(indicator);
		}, 1500);
	}
}




